/* src/app/shared/components/footer/footer.component.scss */
#footer {
  right: 0;
  bottom: 0;
  left: 0;
  padding: 10px 25px;
  background-color: #ffffff;
  border-top: 1px solid #cccccc;
}
.modal-content {
  z-index: 1010;
  text-align: left;
  margin: auto;
}
.modal-dialog {
  position: fixed;
  top: 50%;
  width: 300px;
  z-index: 1010;
  margin: 0px auto;
  transform: translateY(-50%);
  left: calc(50% - 150px);
}
::ng-deep .modal-dialog .modal-content .modal-header-new .close {
  height: 35px !important;
  opacity: 1;
  outline: 0;
  width: 45px !important;
  margin-top: -12px !important;
  right: 0px !important;
  top: 0px !important;
  position: relative !important;
}
.modal-header .close {
  padding: 0rem !important;
  margin: 0rem !important;
}
::ng-deep .modal-dialog .modal-content .modal-footer {
  padding: 8px !important;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
.modal-overlay .modal-container-new {
  position: relative;
  width: 100%;
  background: transparent;
  height: 100%;
}
.modal-overlay .modal-container-new .modal-dialog-copy {
  position: relative;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content {
  height: auto;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-header-new {
  background: #007c91;
  padding: 7px 30px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-header-new h2 {
  color: #fff;
  font-size: 16px;
  font-weight: 700;
  line-height: 25px;
  margin: 0;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-header-new button.close {
  height: 20px;
  width: 20px !important;
  cursor: pointer;
  opacity: 1;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-header-new button.close:focus,
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-header-new button.close:focus-visible,
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-header-new button.close:focus:not(:focus-visible) {
  background-color: transparent;
  opacity: 0.75;
  outline: auto;
  outline-offset: 0;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-header-new button.close:not([disabled]):hover {
  background-color: transparent;
  opacity: 0.75;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-body-copy {
  position: relative;
  flex: 1 1 auto;
  padding: 15px 0 0 30px;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-body-copy .textWidth {
  max-width: 270px;
  display: inline;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-body-copy .section-heading {
  margin: 8px 0 2px 0;
  color: #46707d;
  font-weight: bold;
  font-size: 16px;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-body-copy #emailError {
  color: #b0181e;
  border-radius: 5px;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-footer-new {
  display: flex;
  align-items: center;
  padding: 1rem;
  border-top: 1px solid #e9ecef;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-footer-new .okButton {
  width: 25% !important;
}
.modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-footer-new button {
  width: 130px;
}
.modal-overlay .modal-container-new .alert-modal-dialog {
  width: 450px !important;
}
::ng-deep .ahe-ui-checkbox > input[type=checkbox] {
  margin: 8px 8px !important;
  transform: translateY(0em) !important;
}
#showEmailModal .ahe-ui-checkbox {
  display: flex;
  padding: 8px 0;
  font-weight: 700;
}
#showEmailModal .ahe-ui-checkbox .checkbox-wrapper {
  margin: -8px -8px 0 0;
}
@media (max-width: 575px), (max-height: 400px) {
  #showEmailModal .modal-overlay,
  #alertMessageModal .modal-overlay {
    display: flex;
    justify-content: center;
    padding: 24px 0;
  }
  #showEmailModal .modal-overlay .modal-container-new,
  #alertMessageModal .modal-overlay .modal-container-new {
    max-width: 90vw;
    display: flex;
  }
  #showEmailModal .modal-overlay .modal-container-new .modal-dialog-copy,
  #alertMessageModal .modal-overlay .modal-container-new .modal-dialog-copy {
    width: 100%;
  }
  #showEmailModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content,
  #alertMessageModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content {
    height: fit-content;
    max-height: 100%;
  }
  #showEmailModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-header-new,
  #alertMessageModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-header-new {
    padding: 12px 18px 12px 18px;
    display: flex;
    align-items: center;
    height: 45px;
  }
  #showEmailModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-body-copy,
  #alertMessageModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-body-copy {
    overflow-x: hidden;
    padding: 16px 12px 16px 7px;
    font-size: 12px;
    width: 100%;
    margin: 0;
  }
  #showEmailModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-footer-new,
  #alertMessageModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-footer-new {
    display: flex;
  }
  #showEmailModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-footer-new .okButton,
  #alertMessageModal .modal-overlay .modal-container-new .modal-dialog-copy .modal-content .modal-footer-new .okButton {
    width: 39% !important;
  }
}
/*# sourceMappingURL=footer.component.css.map */
